module.exports = __webpack_public_path__ + "assets/img/gzh.2b9119d1.png";